import script from "./GastonDefendsMasterThesis.vue?vue&type=script&setup=true&lang=js"
export * from "./GastonDefendsMasterThesis.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__